import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_basic-check",
  "use": "icon_basic-check-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon_basic-check\"><path d=\"M8.79289 19.1643L2.29288 12.6643C1.90237 12.2738 1.90237 11.6406 2.29288 11.2501L3.70706 9.83585C4.09757 9.44531 4.73077 9.44531 5.12128 9.83585L9.5 14.2145L18.8787 4.83585C19.2692 4.44534 19.9024 4.44534 20.2929 4.83585L21.7071 6.25007C22.0976 6.64058 22.0976 7.27374 21.7071 7.66429L10.2071 19.1643C9.81656 19.5548 9.1834 19.5548 8.79289 19.1643Z\" fill=\"white\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol